export const locale = {
  lang: 'it',
  data: {
    NAV: {
      ADMIN: 'Admin',
      USER: 'Utente',
      USERS_MANAGEMENT: 'Gestione agenti',
      PROFILE: 'Profilo',
      ACCOUNT: 'Account',
      MASTER: 'Master',
      SELLER: {
        PROFILE: 'Profilo personale',
        INVOICE: 'Fatture',
        INVOICE_ADD: 'Bozza',
        INVOICE_EVALUATION: 'In lavorazione',
        INVOICE_EVALUATION_ALL: 'Tutte',
        INVOICE_EVALUATION_PENDING_DEBTOR_VALIDATION: 'Attesa conferma debitore',
        INVOICE_EVALUATION_PENDING_INVOICE_VALIDATION: 'Controllo dati e documenti',
        INVOICE_EVALUATION_READY: 'Pronte per la cessione',
        INVOICE_EVALUATION_INVALID: 'Non cedibili',
        INVOICE_PENDING: 'Attesa approvazione',
        INVOICE_REJECTED: 'Scartate',
        INVOICE_SOLD: 'Cedute',
        INVOICE_SOLD_ACTIVE: 'In attesa pagamento debitore',
        INVOICE_SOLD_ARCHIVED: 'Pagate',
        AUCTION: 'Aste',
        AUCTION_ALL: 'Tutte',
        AUCTION_IN_PROGRESS: 'In asta',
        AUCTION_SOLD: 'Vendute',
        AUCTION_EXPIRED: 'Non cedute',
        CLIENT: 'Analisi clienti',
        DOCUMENT: 'Documenti',
        DOCUMENT_AML: 'Documenti AML',
      },
      BUYER: {
        PROFILE: 'Profilo personale',
        AUCTIONS_PROGRESS: 'Aste in corso',
        AUCTIONS_CURRENT: 'Correnti',
        AUCTIONS_FUTURE: 'Future',
        AUCTIONS_AWARDED: 'Aste aggiudicate',
        AUCTIONS_AWARDED_ALL: 'Tutte',
        AUCTIONS_AWARDED_PENDING_DOWNPAYMENT: 'Acconto da versare',
        AUCTIONS_AWARDED_PENDING_SETTLEMENT: 'Saldo da versare',
        AUCTIONS_ALL: 'Tutte',
        AUCTIONS_DEPOSIT: 'Acconto da versare',
        AUCTIONS_BALANCE: 'Saldo da versare',
        FINALIZE_MATTERS: 'Pratiche chiuse',
      },
      PARTNER: {
        AUCTIONS: 'Fatture',
        AUCTION_REPORT: 'Fatture cedute',
        AUCTION_EXPIRED: 'Fatture non cedute',
        SOLD_PENDING_SETTLEMENT: 'Aste in saldo da versare',
        SOLD_PAYMENT_EXPIRED: 'Aste da sollecitare',
        COMPANIES: 'Aziende',
      },
      PARTNER_PROFILE_TYPE: {
        PARTNER: 'Master',
        PARTNER_BRANCH_MANAGER: 'Responsabile filiale',
        PARTNER_AGENT: 'Agente',
      },
    },
  },
};
